import { render, staticRenderFns } from "./Leaf.vue?vue&type=template&id=52692a02&scoped=true&"
import script from "./Leaf.vue?vue&type=script&lang=js&"
export * from "./Leaf.vue?vue&type=script&lang=js&"
import style0 from "./Leaf.vue?vue&type=style&index=0&id=52692a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52692a02",
  null
  
)

export default component.exports